import loadable from '@loadable/component';
import { PlansNative } from '@/components/OurPlans/components/PlansNative';

const OurPlans = loadable(() => import('@/components/OurPlans/OurPlans'));

const PlansPage: typeof PlansNative | typeof OurPlans =
  RUNTIME_ENV === 'native' ? PlansNative : OurPlans;

export default PlansPage;
